module.exports = {
        srcSet: __webpack_public_path__ + "static/media/paper-and-pen-400.76055cf8.webp"+" 400w",
        images: [{path: __webpack_public_path__ + "static/media/paper-and-pen-400.76055cf8.webp",width: 400,height: 400}],
        src: __webpack_public_path__ + "static/media/paper-and-pen-400.76055cf8.webp",
        toString: function(){return __webpack_public_path__ + "static/media/paper-and-pen-400.76055cf8.webp"},
        
        width: 400,
        height: 400
      }